import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseValueAccessor } from 'src/app/core/base/base.value-accessor';
import { CommonQuestionViewModel } from 'src/app/model/common/question.view';
import esTranslation from 'src/assets/translations/es.json';

@Component({
  selector: 'ms-odonto-top-bottom-questions',
  templateUrl: './odonto.top-bottom-questions.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: OdontoTopBottomQuestionsComponent,
      multi: true,
    },
  ],
})
export class OdontoTopBottomQuestionsComponent extends BaseValueAccessor<
  CommonQuestionViewModel[]
> {
  readonly screen: any = esTranslation;
  @Input() name = "";
  @Input() turn = -1;
  @Input() readonly = false;
}
